exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".list-enter-active[data-v-49caac8f] {\n  transition: all 0.5s;\n}\n.list-leave-active[data-v-49caac8f] {\n  position: absolute;\n}\n.list-enter[data-v-49caac8f],\n.list-leave-to[data-v-49caac8f] {\n  opacity: 0;\n  transform: translateY(30px);\n}\n.list-move[data-v-49caac8f] {\n  transition: transform 0.3s;\n}\n", ""]);

